import React from 'react';
import { hot } from 'react-hot-loader/root';
import { HashRouter as Router, Switch, Route } from 'react-router-dom';
import styled, { ThemeProvider } from 'styled-components';
// import { I18nextProvider } from 'react-i18next';
// import i18n from './i18n';
import { Home } from './routes/Home';
import { ErrorPage } from './routes/Error';
import { SelectProducts } from './routes/SelectProducts';
import { ReturnDetails } from './routes/ReturnDetails';
import GlobalStateProvider from './store/globalState';
import customTheme from './theme';
// import { getLanguage } from './utils';

require('./enumerateOrders.ts');

const App: React.FC = () => {
  // const lang = getLanguage();
  // console.log('lang', lang);
  // i18n.changeLanguage(lang);
  return (
    <ThemeProvider theme={customTheme}>
      <GlobalStateProvider>
        {/* <I18nextProvider i18n={i18n}> */}
        <Router>
          {/* <GlobalStyles /> */}
          <Wrapper>
            <Switch>
              <Route exact path="/" component={Home} />
              <Route exact path="/select-products" component={SelectProducts} />
              <Route exact path="/return-details" component={ReturnDetails} />
              <Route component={ErrorPage} />
            </Switch>
          </Wrapper>
        </Router>
        {/* </I18nextProvider> */}
      </GlobalStateProvider>
    </ThemeProvider>
  );
};

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  min-height: 100%;
  flex-direction: column;
  max-width: 1024px;
  margin: 32px auto 0 auto;
  font-family: 'Clas Ohlson Sans Web', 'Open Sans', 'Arial' !important;
  input,
  textarea,
  button {
    font-family: 'Clas Ohlson Sans Web', 'Open Sans', 'Arial' !important;
  }
  a {
    color: #000;
    text-decoration: underline;
    font-weight: bold;
    transition: color 0.15s ease;
    &:active,
    &:hover {
      color: #008dc1;
    }
  }
  @media screen and (max-width: 640px) {
    padding: 12px;
  }
`;

// const GlobalStyles = createGlobalStyle`
// html * {
//   box-sizing: border-box;
// }
// html, body {
//   margin: 0;
//   padding: 0;
//   height: 100%;
//   width: 100%;
// }
// body {
//   font-size: 16px;
//   color: #000;
//   background: #FFF;
//   font-family: 'Clas Ohlson Sans Web', 'Open Sans', 'Arial'!important;
// }
// p {
//   margin-top: 0;
// }
// `;

// export default App;
export default hot(App);
